import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFetch, usePromise } from '@rad/hooks';
import PropertyListSkeleton from '../_shared/components/property-list-skeleton';
import SavedPropertyRow from './components/saved-property-row';
import { getSavedProperties } from '../../common/network/saved-property';
import { useSavedProperties } from '../../contexts/saved-properties';
// Unsaving a home here takes it off the page straight away, the way it leaves the list.
const SavedPropertiesPage = (props) => {
    const [savedP] = useFetch(getSavedProperties);
    const saved = usePromise(savedP);
    const savedProperties = useSavedProperties();
    if (saved === undefined || !savedProperties.isLoaded) {
        return _jsx("div", { className: "container py-5", children: _jsx(PropertyListSkeleton, { rows: 3 }) });
    }
    const visible = saved.filter(x => savedProperties.isSaved(x.parcelId));
    return (_jsx("div", { className: "container py-5", children: visible.length === 0 ? (_jsxs("div", { className: "text-center py-5", children: [_jsx("i", { className: "bi bi-heart text-muted", style: { fontSize: '3rem' } }), _jsx("p", { className: "text-muted mt-3 mb-0", children: "You haven't saved any homes yet. Select the heart on any property and it will appear here." })] })) : (_jsx("div", { className: "d-flex flex-column", children: visible.map(x => _jsx(SavedPropertyRow, { property: x }, x.parcelId)) })) }));
};
export default SavedPropertiesPage;
